const isPageReloaded = () => {
  if (window?.performance) {
    return (window?.performance?.getEntriesByType('navigation')?.[0] as any)?.type === 'reload';
  }
};
export default isPageReloaded;
